/**
 * API + hooks React Query pour l'historique des modifications de champs
 * d'un dossier client (côté CGP).
 */

import { useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type { FieldHistoryRead, HistorySession } from "./schema";

export const historyApi = {
  raw: (cfId: string, limit = 200) =>
    api.get<FieldHistoryRead[]>(`/client-files/${cfId}/history/raw?limit=${limit}`),
  grouped: (cfId: string) => api.get<HistorySession[]>(`/client-files/${cfId}/history`),
};

export const historyKeys = {
  all: ["history"] as const,
  raw: (cfId: string) => ["history", "raw", cfId] as const,
  grouped: (cfId: string) => ["history", "grouped", cfId] as const,
};

export function useHistoryRaw(cfId: string | undefined, limit = 200) {
  return useQuery({
    queryKey: cfId ? [...historyKeys.raw(cfId), limit] : ["history", "noop"],
    queryFn: () => historyApi.raw(cfId as string, limit),
    enabled: !!cfId,
  });
}

export function useHistoryGrouped(cfId: string | undefined) {
  return useQuery({
    queryKey: cfId ? historyKeys.grouped(cfId) : ["history", "noop"],
    queryFn: () => historyApi.grouped(cfId as string),
    enabled: !!cfId,
  });
}
